import { useEffect } from 'react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { verifyEmailApi } from '../../apis';
import { handleApiError } from '../../helpers';
import { VerifyEmailDto } from '../../interfaces';

const useConfirmEmail = () => {
  const { email, token } = useParams<{ email: string; token: string }>();
  const [loading, setLoading] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const [error, setError] = useState<string | null>();

  useEffect(() => {
    setLoading(true);
    setError(null);
    const payload: VerifyEmailDto = {
      token,
    };
    verifyEmailApi(payload)
      .then(() => {
        setLoading(false);
        setSuccess(true);
      })
      .catch((error) => {
        setLoading(false);
        setError(handleApiError(error));
      });
  }, [email, token, setError]);

  return { loading, success, error };
};

export default useConfirmEmail;
